import { render, staticRenderFns } from "./GatewayDetailsDetails.vue?vue&type=template&id=067902ae&scoped=true&"
import script from "./GatewayDetailsDetails.vue?vue&type=script&lang=ts&"
export * from "./GatewayDetailsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./GatewayDetailsDetails.vue?vue&type=style&index=0&id=067902ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067902ae",
  null
  
)

export default component.exports